module.exports = "/_next/static/images/loading_04-347f0f5f89e67cf056914eed108d61ea.png";